<template>
  <div class="announcement-view">
    <div
      class="side-menu"
      :class="{
        mobile: width < 760,
      }"
    >
      <ul class="menu-list">
        <!-- MENU LINKLER-->
        <!-- TR BÖLÜMÜ PRESS CLIPPING -->
        <router-link
          v-if="lng == 'tr'"
          class="menu-btn"
          tag="li"
          :to="`/${lng}/press/press_clippings/${menu.press_clippings[0].from}_${
            menu.press_clippings[0].to ? menu.press_clippings[0].to : ''
          }`"
          :class="{
            active: $route.params.type == 'press_clippings',
          }"
        >
          <a href="javascript:;">{{ t.press.pressClipping }}</a>
        </router-link>
        <li
          v-if="lng == 'tr'"
          :class="{
            'dropdown-li': true,
            active: dropdownSelect == 'press_clippings',
          }"
        >
          <!-- SMALL SCREEN SIDE MENU -->
          <div
            class="mobile-menu"
            v-if="width < 760 && dropdownSelect == 'press_clippings'"
          >
            <button class="diginity dg-left-arrow-thin" id="slide-nav__prev"></button>
            <swiper class="swiper" :options="options">
              <swiper-slide v-for="(item, i) in menu.press_clippings" :key="i">
                <!-- router button -->
                <router-link
                  :to="`/${lng}/press/press_clippings/${item.from}_${
                    item.to ? item.to : ''
                  }`"
                  active-class="active"
                  >{{ `${item.from} - ${item.to ? item.to : ""}` }}</router-link
                >
              </swiper-slide>
            </swiper>
            <button class="diginity dg-right-arrow-thin" id="slide-nav__next"></button>
          </div>
          <!-- LARGE SCREEN SIDE MENU -->
          <ul v-else class="dropdown">
            <li v-for="(item, i) in menu.press_clippings" :key="i">
              <router-link
                :to="`/${lng}/press/press_clippings/${item.from}_${
                  item.to ? item.to : ''
                }`"
                active-class="active"
                >{{ `${item.from} - ${item.to ? item.to : ""}` }}</router-link
              >
            </li>
          </ul>
        </li>
        <!-- EN BÖLÜMÜ PRESS CLIPPING -->
        <router-link
          v-if="lng !== 'tr'"
          class="menu-btn"
          tag="li"
          :to="`/${lng}/press/foreign_press_clippings/${
            menu.foreign_press_clippings[0].from
          }_${
            menu.foreign_press_clippings[0].to_ ? enu.foreign_press_clippings[0].to : ''
          }`"
          :class="{
            active: $route.params.type == 'foreign_press_clippings',
          }"
        >
          <a href="javascript:;">{{ t.press.foreignPress }}</a>
        </router-link>
        <!-- dropdown -->
        <li
          v-if="lng !== 'tr'"
          :class="{
            'dropdown-li': true,
            active: dropdownSelect == 'foreign_press_clippings',
          }"
        >
          <!-- SMALL SCREEN SIDE -->
          <div
            class="mobile-menu"
            v-if="width < 760 && dropdownSelect == 'foreign_press_clippings'"
          >
            <button class="diginity dg-left-arrow-thin" id="slide-nav__prev"></button>
            <swiper class="swiper" :options="options">
              <swiper-slide v-for="(item, i) in menu.foreign_press_clippings" :key="i">
                <router-link
                  :to="`/${lng}/press/foreign_press_clippings/${item.from}_${
                    item.to ? item.to : ''
                  }`"
                  active-class="active"
                  >{{ `${item.from} - ${item.to ? item.to : ""}` }}</router-link
                >
              </swiper-slide>
            </swiper>
            <button class="diginity dg-right-arrow-thin" id="slide-nav__next"></button>
          </div>
          <!-- LARGE SCREEN SIDE -->
          <ul v-else class="dropdown">
            <li v-for="(item, i) in menu.foreign_press_clippings" :key="i">
              <router-link
                :to="`/${lng}/press/foreign_press_clippings/${item.from}_${
                  item.to ? item.to : ''
                }`"
                active-class="active"
                >{{ `${item.from} - ${item.to ? item.to : ""}` }}</router-link
              >
            </li>
          </ul>
        </li>
        <!--  PRINT PRESS BÖLÜMÜ (sadece TR de görünüyor -->
        <router-link
          class="menu-btn"
          tag="li"
          :to="`/${lng}/press/print_publications`"
          active-class="active"
          v-if="lng == 'tr'"
        >
          <a href="javascript:;">{{ t.press.printedPublication }}</a>
        </router-link>
        <!-- PHOTO_NOVELS BÖLÜMÜ (sadece tr de görünüyor) -->
        <router-link
          class="menu-btn"
          tag="li"
          :to="`/${lng}/press/photo_novels`"
          active-class="active"
          v-if="lng == 'tr'"
        >
          <a href="javascript:;">{{ t.press.photoNovels }}</a>
        </router-link>
      </ul>
    </div>
    <template v-if="Array.isArray(press_list) && press_list.length">
      <!-- ROUTER VIEW -->
      <router-view />
    </template>
    <!-- Loading Spinner -->
    <template v-else>
      <div class="spinner" v-if="Array.isArray(press_list) && !press_list.length">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
      <p class="response-error" v-if="press_list == undefined">
        <span>{{ lng == "tr" ? "Kayıt bulunamadı" : "No Records Found" }}</span>
      </p>
    </template>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      menu: this.$store.state.press_dates_list,
      width: undefined,
      options: {
        slidesPerView: 3,
        navigation: {
          nextEl: "#slide-nav__next",
          prevEl: "#slide-nav__prev",
        },
        breakpoints: {
          480: {
            slidesPerView: 1,
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters(["t", "lng", "press_list"]),
    // tr or en
    dropdownSelect() {
      return this.$route.params.type;
    },
  },
  watch: {
    $route(newValue, oldValue) {
      if (
        newValue.params.type !== oldValue.params.type ||
        newValue.params.fromTo !== oldValue.params.fromTo
      ) {
        this.$store.dispatch("press_list", {
          category: this.$route.params.type,
          year: this.$route.params.fromTo,
        });
      }
    },
  },
  beforeMount() {
    var self = this;
    // get windowWidth
    self.$nextTick(() => {
      window.addEventListener("resize", () => {
        self.width = window.innerWidth;
      });
    });
  },
  created() {
    this.$scrollTo("body", this.$store.state.scrollSpeed);
    this.width = window.innerWidth;
    this.$store.dispatch("press_list", {
      category: this.$route.params.type,
      year: this.$route.params.fromTo,
    });
  },
  components: {
    swiper,
    swiperSlide,
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/colors";
.announcement-view {
  background: #e7e7e7;
  display: flex;
  flex-wrap: wrap;
  @media screen and (max-width: 760px) {
    flex-direction: column;
  }
  /*  CONTENT */
  .content {
    flex: 1;
    position: relative;
    padding: 10px 20px;
    @media screen and (max-width: 760px) {
      width: 100%;
      flex: 1 auto;
    }
    .content-header {
      padding: 20px 0;
      h3 {
        display: inline-block;
        padding: 7px 15px;
        color: #222;
        border: 3px solid #949195;
        border-left-color: transparent;
        border-right-color: transparent;
        font-weight: normal;
        font-size: 16px;
        margin: 0 0 0 20px;
        @media screen and (max-width: 760px) {
          margin-left: 0;
        }
      }
    }
  }
}
.side-menu {
  min-width: 260px;
  padding: 30px 5px 10px;
  &.mobile {
    width: 100%;
  }
  ul.menu-list {
    // mobile menu
    @media screen and (max-width: 760px) {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
    }
    li.menu-btn {
      margin: 5px;
      @media screen and (max-width: 760px) {
        width: 100%;
      }
      & > a {
        background: #87888a;
        color: #fff;
        text-align: center;
        padding: 7px;
        font-size: 14px;
        display: block;
      }
      &.active {
        & > a {
          background: $main;
        }
        ul.dropdown {
          display: block;
        }
      }
      ul.dropdown {
        padding: 5px 0;
        display: none;
        li {
          a {
            display: block;
            font-size: 14px;
            padding: 5px 8px;
            color: #555;
            font-weight: 500;
            &:hover {
              color: $main;
              background: #ddd;
            }
            &.active {
              font-weight: bold;
              color: $main;
              background: #e8e8e8 !important;
            }
          }
        }
      }
    }
  }
}
.dropdown-li {
  width: 100%;
  &.active {
    ul.dropdown {
      display: block;
    }
  }
  ul.dropdown {
    display: none;
    li {
      a {
        display: block;
        font-size: 14px;
        padding: 5px 8px;
        color: #555;
        font-weight: 500;
        &:hover {
          color: $main;
          background: rgba(221, 221, 221, 0.5);
        }
        &.active {
          font-weight: bold;
          color: $main;
          background: transparent !important;
        }
      }
    }
  }
  .mobile-menu {
    display: flex;
    flex-wrap: nowrap;
    padding: 5px 0;
    button {
      background: none;
      border: none;
      color: $main;
      padding: 5px;
      outline: none;
      font-size: 20px;
      cursor: pointer;
      &.swiper-button-disabled {
        color: #ccc;
      }
    }
    .active {
      color: $main;
      font-weight: bold;
    }
    .swiper {
      flex: 1 auto;
      .swiper-slide {
        a {
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          width: 90%;
          height: 100%;
          &:hover {
            color: $main;
            // background: #ddd;
          }
        }
      }
    }
    &.swiper-button-disabled {
      display: none;
    }
  }
}
</style>
